import UploadProgressBar from 'app/components/UploadProgressBar';

const GuestUploadProgressBar = props => {
  const {
    guest,
    inModal
  } = props;

  //const matchFileContext = fileContext => {
  //  const {
  //    story_ids
  //  } = fileContext
  //
  //  return story_ids?.indexOf(guest.story_id) !== -1;
  //}
  let matchFileContext = {
    story_ids: [guest.story_id]
  }

  let total = guest.photo_count;
  let loaded = guest.actual_photo_count;

  return <UploadProgressBar {...{ matchFileContext, total, loaded, inModal }} />;
}

export default GuestUploadProgressBar;
